import React from 'react'
import { Deal } from 'scenes/Dashboard/data/deals/types'
import { Organization } from 'scenes/Dashboard/data/organizations/types'

import { createStyles, Theme, Typography } from '@mui/material'
import { WithStyles, withStyles, WithTheme } from '@mui/styles'

import OrganizationLogo from '../OrganizationLogo'

const OrganizationModalHeader: React.SFC<OrganizationModalHeaderProps & WithStyles<typeof styles> & WithTheme> = ({
  classes,
  theme,
  deal = {} as Deal,
  organization = {} as Organization,
}) => {
  const { name: organizationName = 'Loading' } = organization
  const { source } = deal
  return (
    <div className={classes.container}>
      <OrganizationLogo
        source={source}
        organization={organization}
        size={theme.spacing(7)}
        className={classes.organizationLogo}
      />
      <div>
        <Typography variant="h6">{organizationName}</Typography>
      </div>
    </div>
  )
}

export type OrganizationModalHeaderProps = {
  deal?: Deal
  organization?: Organization
}

const styles = ({ spacing }: Theme) => {
  return createStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
    },
    organizationLogo: {
      marginRight: spacing(1.5),
    },
  })
}

export default withStyles(styles, { withTheme: true })(OrganizationModalHeader)
